export default "/bitrix/js/landing/ui/panel/separatorpanel/dist/images/page.png"